import { Component, inject } from '@angular/core'
import { CustomerNavigationService } from '@shared/services/customer-navigation.service'
import { TranslateService } from '@ngx-translate/core'
import { Event, NavigationEnd, Router, RouterOutlet } from '@angular/router'
import { Store } from '@ngrx/store'
import { AppActions } from './store/app.actions'

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  imports: [RouterOutlet],
})
export class AppComponent {
  private router = inject(Router)
  private customerNavigationService = inject(CustomerNavigationService)
  private translateService = inject(TranslateService)
  private store = inject(Store)

  locale = 'sv'

  constructor() {
    const customerNavigationService = this.customerNavigationService
    const translateService = this.translateService

    translateService.use(this.locale)
    customerNavigationService.init()

    // istanbul ignore next
    this.router.events.subscribe((event: Event) => {
      if (event instanceof NavigationEnd) {
        if (event.url.startsWith('/pay')) {
          this.store.dispatch(AppActions.hideNotice())
        } else {
          this.store.dispatch(AppActions.showNotice())
        }
      }
    })
  }
}
